import { ExclusiveTreatmentCalculator } from '../../models/Treatment/ExclusiveTreatmentCalculator';
import { InclusiveTreatmentCalculator } from '../../models/Treatment/InclusiveTreatmentCalculator';
import { NotApplicableTreatmentCalculator } from '../../models/Treatment/NotApplicableTreatmentCalculator';
import {
  TaxCalculationEnum,
  TreatmentCalculator,
} from '../../models/Treatment/TreatmentCalculator';
import { CalculationStrategy, LineEntry } from '../../types';
import { LineEntryForm } from '../../types/treatment';

export const TaxCalculatorMap = {
  [TaxCalculationEnum.TaxExcluded]: ExclusiveTreatmentCalculator,
  [TaxCalculationEnum.TaxInclusive]: InclusiveTreatmentCalculator,
  [TaxCalculationEnum.NotApplicable]: NotApplicableTreatmentCalculator,
};

const useTreatmentCalculator = ({
  lineItems,
  taxCalculation,
  usePriceBeforeTax = false,
}: {
  lineItems: LineEntryForm[] | LineEntry[];
  taxCalculation: {
    strategy: CalculationStrategy;
  };
  usePriceBeforeTax?: boolean;
}): {
  totals: {
    subTotal: number;
    taxesSubTotal: number;
    total: number;
  };
  taxCalculation: { strategy: CalculationStrategy };
  treatmentCalculationStrategy: CalculationStrategy;
  lineItems?: LineEntryForm[];
} => {
  const treatmentCalculationStrategy: CalculationStrategy = taxCalculation
    ? taxCalculation.strategy
    : ExclusiveTreatmentCalculator;

  if (lineItems.length < 1) {
    return {
      totals: TreatmentCalculator.formatTotals({
        subTotal: 0,
        taxesSubTotal: 0,
        total: 0,
      }),
      taxCalculation,
      treatmentCalculationStrategy,
    };
  }

  return {
    taxCalculation,
    treatmentCalculationStrategy,
    ...(treatmentCalculationStrategy as CalculationStrategy).calculateLineItemsAndTotals({
      lineItems,
      usePriceBeforeTax,
    }),
  };
};

export default useTreatmentCalculator;
